<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    v-if="movieAudience"
    id="edit_movieAudience"
    class="container-fluid v-scroll edit-movie-audience"
    :class="{ 'pad-bottom': selectedSimilarMovies.length > 0 && wizardStep == 1 }"
    style="background-size: cover"
    :style="
      activeMovie != null
        ? `background-image: url(https://image.tmdb.org/t/p/original/${activeMovie.backdrop_path});`
        : ''
    ">
    <div
      v-if="activeMovie != null"
      class="veil" />
    <div
      class="wizard-header"
      :class="{ hidden: activeMovie == null, visible: activeMovie != null }">
      <template v-if="activeMovie != null">
        <div class="active-movie">
          <img
            :src="`https://image.tmdb.org/t/p/w500/${activeMovie.poster_path}`"
            alt="" />
          <div
            class="flex-v"
            style="flex-grow: 1">
            <span class="title">{{ activeMovie.title }}</span>
            <span class="release-date muted"
              >Release date: {{ DateTime.fromISO(activeMovie.release_date).toLocaleString(DateTime.DATE_SHORT) }}</span
            >
          </div>
          <div
            v-if="wizardStep == 2"
            class="selected-similar-movies"
            :class="{ visible: selectedSimilarMovies.length > 0, hidden: selectedSimilarMovies.length === 0 }">
            <span
              class="ml-2 mt-4 mb-3 muted"
              style="text-align: left"
              >Movies for your target audience</span
            >
            <div class="movie-list">
              <div
                v-for="movie in selectedSimilarMovies"
                :key="movie.id"
                class="similar-movie-result opacify-no-delay"
                style="margin: 0 0.6rem">
                <img
                  class="poster"
                  style="margin: 0; height: 9.6rem"
                  :src="
                    movie.poster_image_thumbnail != null
                      ? movie.poster_image_thumbnail.replace('w154', 'w500')
                      : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
                  " />
              </div>
            </div>
          </div>
          <button
            v-tooltip="'Start over'"
            class="btn-no-borders ml-5"
            @click="startOver">
            <icon-close />
          </button>
        </div>
      </template>
    </div>
    <div class="row">
      <div
        v-if="wizardStep === 1"
        class="col-12">
        <div
          class="form-horizontal"
          :class="{ 'light-text': activeMovie != null }">
          <div :class="{ hidden: activeMovie != null }">
            <div class="form-section group">
              <span>Movie launch audience</span>
            </div>
            <div class="form-section-content">
              <div class="movie-search">
                <!--                <div class="header">What is the name of the movie being launched?</div>-->
                <div class="header">Let's start by finding the movie being launched?</div>
                <div class="textbox-and-button">
                  <input
                    v-model="movieSearchTerm"
                    type="text"
                    class="form-control"
                    placeholder=""
                    @keyup.enter="searchMovies" />
                  <button
                    class="btn btn-primary-hollow btn-md"
                    @click="searchMovies">
                    <icon-search />
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="filteredMovieSearchResults != null"
            class="movie-search-results"
            :class="{ hidden: activeMovie != null }">
            <div
              v-for="movie in filteredMovieSearchResults"
              :key="movie.id"
              class="movie-result opacify-no-delay">
              <img
                class="poster"
                :src="
                  movie.poster_image_thumbnail != null
                    ? movie.poster_image_thumbnail.replace('w154', 'w500')
                    : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
                " />
              <div
                class="overlay"
                @click="
                  (e) => {
                    activateMovie(e, movie);
                  }
                ">
                <button class="btn btn-white-hollow btn-rounded">Select</button>
              </div>
            </div>
          </div>
          <div
            class="movie-search-no-results"
            :class="{
              hidden: filteredMovieSearchResults == null || filteredMovieSearchResults.length > 0,
              visible: filteredMovieSearchResults != null && filteredMovieSearchResults.length === 0,
            }">
            <icon-complex-sad />
            <span class="mt-3 text-muted"> No movies matched your search. </span>
          </div>

          <div v-if="activeMovie != null && similarMovies != null">
            <hr />
            <h3 class="text-center mb-5">
              Now pick movies <b>like</b> <i>&quot;{{ activeMovie.title }}&quot;</i> released in the past year.
            </h3>
            <template v-if="false && topRecommendations.length > 0">
              <h4 class="text-center mb-5">
                <div class="separator">
                  <div class="line" />
                  <div class="text">Your top recommendations</div>
                  <div class="line" />
                </div>
              </h4>
              <div
                class="similar-movie-search-results"
                :class="{ hidden: activeMovie == null }">
                <div
                  v-for="movie in topRecommendations"
                  :key="movie.id"
                  class="similar-movie-result opacify-no-delay">
                  <img
                    class="poster"
                    :src="
                      movie.poster_image_thumbnail != null
                        ? movie.poster_image_thumbnail.replace('w154', 'w500')
                        : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
                    " />
                  <div
                    v-if="selectedSimilarMovies.indexOf(movie) === -1"
                    class="overlay"
                    @click="
                      (e) => {
                        addToSelection(e, movie);
                      }
                    ">
                    <button class="btn-no-borders btn-no-borders-xl">
                      <icon-add />
                    </button>
                  </div>
                  <div
                    v-else
                    class="overlay disabled" />
                </div>
              </div>
            </template>
            <div class="separator mt-5 mb-3">
              <div class="line" />
              <div class="text">Movies in similar categories</div>
              <div class="line" />
            </div>
            <div class="muted text-center"><small>Powered by</small></div>
            <div class="api-logos">
              <international-showtimes-logo />
              <t-m-d-b-logo />
            </div>
            <h5 class="text-center mb-5 muted">Toggle categories to filter the list.</h5>
            <div class="genres mb-5">
              <button
                v-for="genre in activeFullMovie.genres"
                :key="genre.id"
                class="btn btn-white-hollow btn-rounded"
                :class="{ 'btn-primary': selectedGenres.find((g) => g.id === genre.id) != null }"
                @click="toggleGenre(genre)">
                {{ genre.name }}
              </button>
            </div>
            <div
              class="similar-movie-search-results"
              :class="{ hidden: activeMovie == null }">
              <template v-if="filteredSimilarMovies.length > 0">
                <div
                  v-for="movie in filteredSimilarMovies"
                  :key="movie.id"
                  class="similar-movie-result opacify-no-delay">
                  <img
                    class="poster"
                    :src="
                      movie.poster_image_thumbnail != null
                        ? movie.poster_image_thumbnail.replace('w154', 'w500')
                        : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
                    " />
                  <div
                    v-if="selectedSimilarMovies.indexOf(movie) === -1"
                    class="overlay"
                    @click="
                      (e) => {
                        addToSelection(e, movie);
                      }
                    ">
                    <button class="btn-no-borders btn-no-borders-xl">
                      <icon-add />
                    </button>
                  </div>
                  <div
                    v-else
                    class="overlay disabled" />
                </div>
                <div
                  v-if="!hasReachedLastPageOfSimilarMovies"
                  class="more-similar-movie-results opacify-no-delay">
                  <button
                    class="btn btn-white-hollow btn-rounded"
                    @click="moreSimilarMoviesFromTheMovieDB">
                    more
                  </button>
                </div>
              </template>
            </div>
          </div>
          <div
            class="selected-similar-movies floating"
            :class="{ visible: selectedSimilarMovies.length > 0, hidden: selectedSimilarMovies.length === 0 }">
            <div class="movie-list">
              <div
                v-for="movie in selectedSimilarMovies"
                :key="movie.id"
                class="similar-movie-result opacify-no-delay">
                <img
                  class="poster"
                  :src="
                    movie.poster_image_thumbnail != null
                      ? movie.poster_image_thumbnail.replace('w154', 'w500')
                      : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`
                  " />
                <div
                  class="overlay"
                  @click="
                    (e) => {
                      removeFromSelection(e, movie);
                    }
                  ">
                  <button class="btn-no-borders btn-no-borders-xl">
                    <icon-delete />
                  </button>
                </div>
              </div>
            </div>
            <button
              class="btn btn-white-hollow btn-md"
              @click="wizardStep = 2">
              Choose a market and find showtimes
            </button>
          </div>

          <!--          <div class="form-footer row">-->
          <!--            <div class="col-12 col-sm-6">-->
          <!--              <button id="edit_movie_audience_cancel_btn" class="btn btn-default" @click="cancel">-->
          <!--                {{ capitalize($t('actions.cancel')) }}-->
          <!--              </button>-->
          <!--            </div>-->
          <!--            <div class="col-12 col-sm-6">-->
          <!--              <button id="edit_movie_audience_save_btn" class="btn btn-primary btn-right" @click="save">-->
          <!--                {{ capitalize($t('actions.save')) }}-->
          <!--              </button>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div
        v-if="wizardStep === 2"
        class="col-12 light-text">
        <div class="row">
          <div class="col-12">
            <div
              v-if="selectedCity == null"
              class="flex-v mb-5"
              style="align-items: center">
              <h4 class="m-4">Which market are you looking to advertise in?</h4>
              <multiselect
                v-model="selectedCity"
                class="ml-4"
                label="displayName"
                track-by="slug"
                placeholder="Type to search"
                open-direction="bottom"
                :options="cities"
                :multiple="false"
                :searchable="true"
                :loading="isLoadingCities"
                :internal-search="false"
                :options-limit="300"
                :max-height="600"
                :show-no-results="false"
                @search-change="findCities">
                <template #clear="props">
                  <div
                    v-if="selectedCity != null"
                    class="multiselect__clear"
                    @mousedown.prevent.stop="clearAll(props.search)" />
                </template>
                <template #noResult>Oops! No market found. Consider changing the search query.</template>
              </multiselect>
            </div>
            <template v-else>
              <div class="flex-h">
                <span
                  class="badge badge-info-hollow badge-rounded mb-4 mt-4"
                  style="cursor: pointer"
                  @click="clearCity"
                  >Market: {{ selectedCity.name }} &times;</span
                >
                <div class="filler" />
                <tabs
                  :tabs="tabs"
                  theme="dark"
                  style="margin-bottom: 0"
                  :selected-tab-i-d="selectedTab != null ? selectedTab.id : null"
                  @changed="onTabChanged" />
                <div class="filler" />
                <button
                  class="btn btn-primary btn-sm mt-4 mb-4"
                  @click="saveGeofencesAndCreateAudience">
                  Generate geofences and audience
                </button>
              </div>
            </template>
          </div>
          <!--          <div class="col-md-6 col-12">-->
          <!--            <div class="selected-similar-movies"-->
          <!--                 :class="{ visible: selectedSimilarMovies.length > 0, hidden: selectedSimilarMovies.length === 0 }">-->
          <!--              <h4 class="mt-4">Your movie selection</h4>-->
          <!--              <div class="movie-list">-->
          <!--                <div v-for="movie in selectedSimilarMovies"-->
          <!--                     class="similar-movie-result opacify-no-delay">-->
          <!--                  <img class="poster"-->
          <!--                       :src="movie.poster_image_thumbnail != null ? movie.poster_image_thumbnail.replace('w154', 'w500') : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`">-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div
          v-if="showtimesForSelectedMoviesAndCity != null"
          v-show="selectedTab == null || selectedTab.id === 'tabmapInternal'"
          class="map-container">
          <div
            v-if="selectedCinema != null"
            class="cinema-details">
            <div>
              <img
                v-if="chainLogos[selectedCinema.chain_id] != null"
                class="mb-3 chain-logo"
                :src="chainLogos[selectedCinema.chain_id]"
                alt="" />
              <div class="title mb-1">{{ selectedCinema.name }}</div>
              <div class="mb-3">
                <small>{{ selectedCinema.location.address.display_text }}</small>
              </div>
              <div class="movies">
                <template v-if="showtimesForSelectedMoviesAndCity != null">
                  <div
                    v-for="([movieID, showtimes], i) in Object.entries(
                      showtimesForSelectedMoviesAndCity
                        .filter((x) => x.cinema_id == selectedCinema.id)
                        .reduce((mem, x) => {
                          if (mem[x.movie_id] == null) {
                            mem[x.movie_id] = [x];
                          } else {
                            mem[x.movie_id].push(x);
                          }
                          return mem;
                        }, {}),
                    )"
                    :key="i"
                    class="movie-showtimes opacify-long">
                    <img
                      class="mb-3"
                      :src="getMoviePosterUrl(movieID)" />
                    <div class="mb-4">
                      <b>{{ showtimes.length }}</b> showtimes
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="map-and-timeline">
            <div id="map" />
            <div class="timeline-and-controls">
              <div class="controls">
                <button
                  class="btn btn-white-hollow btn-rounded btn-sm"
                  @click="isTimelinePlaying = !isTimelinePlaying">
                  <span v-if="isTimelinePlaying">Pause</span>
                  <span v-else>Play</span>
                </button>
              </div>
              <div
                v-if="showtimesByHour != null"
                class="timeline"
                @mousemove="onCursorMouseMove"
                @mouseup="onCursorMouseUp">
                <div
                  v-for="(showtimes, i) in showtimesByHour"
                  :key="i"
                  class="hour"
                  :style="`width: ${timelineHourWidth}%;`">
                  <div
                    class="bar"
                    :style="`height: ${showtimes == null ? 0 : (showtimes.length / maxShowtimesPerHour) * 100}%;`" />
                </div>
                <div
                  class="cursor"
                  :style="`left: ${timelineCursorOffset}%;`"
                  unselectable="on"
                  onselectstart="return false;"
                  @mousedown="onCursorMouseDown">
                  <div class="bar" />
                  <div class="cursor-tooltip">
                    {{ timelineCurrentTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="selectedTab != null && selectedTab.id === 'tab_showtimes'"
          class="showtimes-container">
          <table
            v-if="showTimesGrouped != null"
            class="showtimes-table">
            <thead>
              <tr style="border-bottom: solid 1px #ffffff99">
                <th colspan="2">Cinema</th>
                <th>Movie</th>
                <th>Showtimes</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="([, group], i) in Object.entries(showTimesGrouped)"
                :key="i">
                <tr>
                  <td style="padding-top: 0.8rem; vertical-align: top">
                    <img
                      class="mr-2"
                      style="max-height: 4.8rem; max-width: 6.4rem"
                      :src="chainLogos[group.cinema.chain_id]" />
                  </td>
                  <td style="padding-top: 0.8rem; vertical-align: top">{{ group.cinema.name }}</td>
                  <td style="padding-top: 0.8rem; vertical-align: top">
                    <img
                      class="mr-2"
                      style="max-height: 12.8rem"
                      :src="getMoviePosterUrl(group.movie.id)" />
                  </td>
                  <td style="padding-top: 0.8rem; vertical-align: top">
                    <table>
                      <thead>
                        <th
                          v-for="[day] in Object.entries(group.showtimes)"
                          :key="day">
                          {{ day }}
                        </th>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            v-for="([, dailyshowtimes], i) in Object.entries(group.showtimes)"
                            :key="i"
                            style="vertical-align: top; width: 10rem">
                            <div class="flex-v">
                              <div
                                v-for="st in dailyshowtimes"
                                :key="st"
                                class="badge badge-info mb-1">
                                {{ st.toLocaleString(DateTime.TIME_SIMPLE) }}
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <modal
      :id="saveChangesConfirmationModalID"
      :visible="isSaveChangesModalVisible"
      :title="saveChangesConfirmationModalTitle"
      :body="saveChangesConfirmationModalBody"
      :button1-caption="yes"
      :button2-caption="no"
      :button2-visible="true"
      @confirmed="saveChangesModalConfirmed"
      @cancelled="saveChangesModalCancelled" />
    <confirm-losing-changes-modal
      :is-visible="isConfirmLosingChangesModalVisible"
      :confirm-callback="confirmLosingChangesCallback"
      @confirmed="
        () => {
          isConfirmLosingChangesModalVisible = false;
        }
      "
      @cancelled="
        () => {
          isConfirmLosingChangesModalVisible = false;
        }
      " />
  </div>
</template>

<script type="text/babel">
  /* eslint-disable */
  import { mapActions } from 'vuex';
  import numbro from 'numbro';
  import UserNotifications from '@/utils/UserNotifications';
  import { DateTime } from 'luxon';
  import axios from 'axios';
  import mapboxgl from 'mapbox-gl';

  import { capitalize } from 'vue';
  import { ConfirmLosingChangesModal, DatePicker, FormLabel, Tabs } from '@/common/components/controls';

  import { IconColoredAccount, IconColoredAdvertiser } from '@/common/icons/colored';

  import { IconComplexSad, IconComplexDone } from '@/common/icons/complex';

  import {
    IconAdd,
    IconClose,
    IconInfo,
    IconRemoveFromCart as IconDelete,
    IconSearch,
  } from '@/common/icons/monochrome';
  import { FullDaypart } from '@/globals';

  import orgAppApi from '../../api';
  import GeofenceGroupType from '@/common/models/geofenceGroups/GeofenceGroupType.enum';
  import Geofence from '@/common/models/geo/Geofence';
  import AudienceRule from '@/common/models/audience/AudienceRule';
  import AudienceLookBackWindow from '@/common/models/audience/AudienceLookBackWindow';

  import theMovieDBApi from '@/common/apis/theMovieDBApi';
  import internationalShowtimesApi from '@/common/apis/internationalShowtimesApi';
  import colors from '@/Colors';
  import i18n from '@/vueI18n';

  import InternationalShowtimesLogo from './data/api-providers/InternationalShowtimesLogo';
  import TMDBLogo from './data/api-providers/TMDBLogo';
  import LogoAMC from './data/logos/amc.png';
  import LogoArclightCinemas from './data/logos/arclight-cinemas.png';
  import LogoCinemark from './data/logos/cinemark.png';
  import LogoLandmarkCinemas from './data/logos/landmark-cinemas.jpg';
  import LogoRegalCinemas from './data/logos/regal-cinemas.png';
  import MapLogoAMC from './data/map-logos/amc.png';
  import MapLogoArclightCinemas from './data/map-logos/arclight-cinemas.png';
  import MapLogoCinemark from './data/map-logos/cinemark.png';
  import MapLogoLandmarkCinemas from './data/map-logos/landmark-cinemas.png';
  import MapLogoRegalCinemas from './data/map-logos/regal-cinemas.png';
  import MessageCollection from '@/validator/MessageCollection';
  import { AudienceRuleModes } from '@/common/enums/audience-rule-modes';
  import { FilterCollection, FilterComparisonOperator, QueryParams } from '@/common/models';

  const selectedCity = {
    id: '1606',
    name: 'Los Angeles',
    slug: 'los-angeles',
    lat: -37.4707,
    lon: -72.3517,
    country: 'US',
  };
  const chainLogos = {
    26: LogoAMC,
    27: LogoRegalCinemas,
    29: LogoCinemark,
    33: LogoLandmarkCinemas,
    44: LogoArclightCinemas,
  };
  const chainMapLogos = {
    26: MapLogoAMC,
    27: MapLogoRegalCinemas,
    29: MapLogoCinemark,
    33: MapLogoLandmarkCinemas,
    44: MapLogoArclightCinemas,
  };
  const SIMILAR_MOVIES_PAGE_SIZE = 30;

  export default {
    components: {
      ConfirmLosingChangesModal,
      DatePicker,
      FormLabel,
      IconAdd,
      IconClose,
      IconColoredAccount,
      IconColoredAdvertiser,
      IconComplexDone,
      IconComplexSad,
      IconInfo,
      IconDelete,
      IconSearch,
      InternationalShowtimesLogo,
      TMDBLogo,
      Tabs,
    },
    data() {
      return {
        activeFullMovie: null,
        activeMovie: null,
        chainLogos,
        cinemas: null,
        cities: [],
        colors,
        confirmLosingChangesCallback: null,
        DateTime,
        entityTimestamp: DateTime.local(),
        errors: new MessageCollection(),
        isConfirmLosingChangesModalVisible: false,
        isLoadingCities: false,
        isMapLoaded: false,
        isNew: this.$route.params.id === 'new',
        isSaveChangesModalVisible: false,
        isTimelinePlaying: false,
        movieAudience: {},
        movieSearchResults: null,
        movieSearchTerm: '',
        saveChangesConfirmationModalID: 'edit_movie_audience_save_changes_confirmation_modal',
        selectedCinema: null,
        selectedCity: null,
        selectedGenres: [],
        selectedSimilarMovies: [],
        selectedTab: null,
        showOnlyUpcomingMovies: true,
        showtimes: null,
        similarMovies: null,
        similarMoviesPage: 0,
        similarMoviesTotalPages: 0,
        timelineHourIndex: 0,
        topRecommendations: [],
        wizardStep: 1,
      };
    },
    computed: {
      tabs() {
        return [
          {
            id: 'tabmapInternal',
            name: 'Map',
          },
          {
            id: 'tab_showtimes',
            name: 'Showtimes',
          },
        ];
      },
      filteredMovieSearchResults() {
        if (this.movieSearchResults == null) {
          return null;
        }
        return this.movieSearchResults.movies.filter((x) => x.poster_image_thumbnail != null);

        // return this.movieSearchResults.results.filter(x => x.original_language === 'en'
        //   && !x.adult
        //   && x.poster_path != null
        //   && (!this.showOnlyUpcomingMovies || DateTime.fromISO(x.release_date) > DateTime.local()));
      },
      filteredSimilarMovies() {
        if (this.similarMovies == null) {
          return null;
        }
        if (this.similarMovies.movies != null) {
          return this.similarMovies.movies.filter((m) => m.poster_image_thumbnail != null);
        }
        return this.similarMovies.filter(
          (x) =>
            x.original_language === 'en' &&
            !x.adult &&
            x.poster_path != null &&
            DateTime.fromISO(x.release_date) < DateTime.local() &&
            DateTime.fromISO(x.release_date) > DateTime.local().minus({ years: 1 }),
        );
      },
      listEndpoint() {
        return '/movieAudiences/';
      },
      detailsEndpoint() {
        return `/movieAudiences/${this.movieAudience.id}`;
      },
      no() {
        return capitalize(i18n.global.t('actions.no'));
      },
      yes() {
        return capitalize(i18n.global.t('actions.yes'));
      },
      saveChangesConfirmationModalTitle() {
        const message = this.isNew ? 'saveNewEntity' : 'saveChanges';
        return capitalize(i18n.global.t(`actions.${message}`));
      },
      saveChangesConfirmationModalBody() {
        const message = this.isNew ? 'confirmSaveNewEntity' : 'confirmSaveChanges';
        return capitalize(i18n.global.t(`messages.${message}`));
      },
      currencySymbol() {
        return numbro.languageData().currency.symbol;
      },
      hasReachedLastPageOfSimilarMovies() {
        return this.similarMoviesTotalPages <= this.similarMoviesPage;
      },
      allShowtimes() {
        if (this.showtimes == null) {
          return null;
        }
        return Object.values(this.showtimes).reduce((mem, x) => [...mem, ...x], []);
      },
      cinemasWithShowtimes() {
        if (this.cinemas == null || this.allShowtimes == null) {
          return null;
        }
        return this.cinemas.filter((c) => this.allShowtimes.some((st) => st.cinema_id === c.id));
      },
      showtimesForSelectedMoviesAndCity() {
        if (this.allShowtimes == null || this.cinemas == null) {
          return null;
        }
        return this.allShowtimes.filter((st) => this.cinemas.some((c) => st.cinema_id === c.id));
      },
      showTimesGrouped() {
        if (this.showtimesForSelectedMoviesAndCity == null) {
          return null;
        }
        return this.showtimesForSelectedMoviesAndCity.reduce((mem, st) => {
          const date = DateTime.fromISO(st.start_at);
          const day = DateTime.fromISO(date).startOf('day').toLocaleString(DateTime.DATE_SHORT);
          const key = `${st.cinema_id}-${st.movie_id}`;
          if (mem[key] == null) {
            const val = {
              cinema: this.cinemas.find((x) => x.id === st.cinema_id),
              movie: this.selectedSimilarMovies.find((x) => x.id === st.movie_id),
              showtimes: {},
            };
            mem[key] = val;
          }
          if (mem[key].showtimes[day] == null) {
            mem[key].showtimes[day] = [date];
          } else {
            mem[key].showtimes[day].push(date);
          }
          return mem;
        }, {});
      },
      minShowtimeStart() {
        if (this.showtimesForSelectedMoviesAndCity == null) {
          return null;
        }
        return this.showtimesForSelectedMoviesAndCity.reduce((mem, st) => {
          const date = DateTime.fromISO(st.start_at);
          if (mem == null || mem > date) {
            return date;
          }
          return mem;
        }, null);
      },
      maxShowtimeStart() {
        if (this.showtimesForSelectedMoviesAndCity == null) {
          return null;
        }
        return this.showtimesForSelectedMoviesAndCity.reduce((mem, st) => {
          const date = DateTime.fromISO(st.start_at);
          if (mem == null || mem < date) {
            return date;
          }
          return mem;
        }, null);
      },
      showtimesByHour() {
        const start = DateTime.fromISO(this.minShowtimeStart).startOf('hour');
        const end = DateTime.fromISO(this.maxShowtimeStart).startOf('hour');
        const hours = Array(Math.floor(end.diff(start, 'hours').toObject().hours) + 1).fill(null);
        let lastStartAt = null;
        let lastIndex = -1;
        for (let i = 0; i < this.showtimesForSelectedMoviesAndCity.length; i += 1) {
          const st = this.showtimesForSelectedMoviesAndCity[i];
          if (st.start_at === lastStartAt) {
            hours[lastIndex].push(st);
          } else {
            const index = Math.floor(DateTime.fromISO(st.start_at).diff(start, 'hours').toObject().hours);
            if (hours[index] == null) {
              hours[index] = [st];
            } else {
              hours[index].push(st);
            }
            lastIndex = index;
          }
          lastStartAt = st.start_at;
        }
        // while (current <= this.maxShowtimeStart) {
        //   const next = DateTime.fromISO(current).plus({ hours: 1 });
        //   hours.push(this.showtimesForSelectedMoviesAndCity.filter(x => DateTime.fromISO(x.start_at).isBetween(current, next, null, '[)')));
        //   current.plus({ hours: 1 });
        // }
        return hours;
      },
      maxShowtimesPerHour() {
        return Math.max(...this.showtimesByHour.map((x) => (x == null ? 0 : x.length)));
      },
      timelineHourWidth() {
        return 100 / this.showtimesByHour.length;
      },
      timelineCurrentTime() {
        return DateTime.fromISO(this.minShowtimeStart).plus({ hours: this.timelineHourIndex }).toFormat('MMM DD, LT');
      },
      timelineCursorOffset() {
        return this.timelineHourIndex * this.timelineHourWidth;
      },
      timelineCurrentShowtimes() {
        return this.showtimesByHour[this.timelineHourIndex];
      },
    },
    methods: {
      ...mapActions(['updateGeofenceGroupGeofences']),
      ...mapActions('orgApp', [
        'createNewGeofenceGroup',
        'createNewAudienceLogic',
        'getAllDataProviders',
        'saveGeofenceGroup',
        'saveGeofences',
        'createAudienceLogics',
        'updateAudienceLogic',
        'getGeofenceGroups',
      ]),
      setMapDataSource(map) {
        if (map == null) {
          return;
        }
        const latLngs = [];
        const features = [];
        const polygonFeatures = [];

        if (this.cinemasWithShowtimes != null) {
          this.cinemasWithShowtimes.forEach((cinema) => {
            latLngs.push({ lat: cinema.location.lat, lng: cinema.location.lon });
            features.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [cinema.location.lon, cinema.location.lat],
              },
              properties: {
                id: cinema.id,
                title: cinema.name,
                name: cinema.name,
              },
            });
            if (cinema.geoJson != null) {
              polygonFeatures.push({
                type: 'Feature',
                geometry: cinema.geoJson.geometry,
                properties: {
                  id: cinema.id,
                  title: cinema.name,
                  name: cinema.name,
                },
              });
            }
          });
        }
        if (map.getSource('cinemas') != null) {
          map.getSource('cinemas').setData({
            type: 'FeatureCollection',
            features,
          });
        }
        if (map.getSource('cinema_polygons_source') != null) {
          map.getSource('cinema_polygons_source').setData({
            type: 'FeatureCollection',
            features: polygonFeatures,
          });
        }

        if (this.mapMarkers != null) {
          this.mapMarkers.forEach((m) => m.remove());
        }
        this.mapMarkers = [];
        if (this.cinemasWithShowtimes != null) {
          this.cinemasWithShowtimes.forEach((cinema) => {
            if (chainLogos[cinema.chain_id] == null) {
              return;
            }
            // create a DOM element for the marker
            const el = document.createElement('div');
            el.className = 'marker';
            const img = document.createElement('img');
            img.src = chainMapLogos[cinema.chain_id];
            img.style.width = '32px';
            // img.style.height = '32px';
            el.appendChild(img);

            // add marker to map
            const marker = new mapboxgl.Marker({ element: el, offset: [0, 0] })
              .setLngLat([cinema.location.lon, cinema.location.lat])
              .addTo(map);

            this.mapMarkers.push(marker);
          });
        }
        const fitCinemas = () => {
          if (latLngs.length === 0) {
            return;
          }
          const lats = latLngs.map((x) => x.lat);
          const lngs = latLngs.map((x) => x.lng);
          const minLat = Math.min(...lats) || 0;
          const maxLat = Math.max(...lats) || 0;
          const minLng = Math.min(...lngs) || 0;
          const maxLng = Math.max(...lngs) || 0;

          const bounds = [
            [minLng, minLat],
            [maxLng, maxLat],
          ];

          this.map.fitBounds(bounds, {
            padding: {
              top: 50,
              bottom: 50,
              left: 50,
              right: 50,
            },
            duration: 0,
          });
        };

        fitCinemas();
      },
      initMap() {
        if (this.map == null) {
          const mapOptions = {
            container: 'map',
            style: 'mapbox://styles/mapbox/dark-v9',
            minzoom: 1.3,
            zoom: 10,
            pitch: 30,
          };

          this.isMapLoaded = false;
          const map = new mapboxgl.Map(mapOptions);
          map.on('load', () => {
            this.map.addSource('cinemas', {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: [],
              },
            });

            this.map.addSource('cinema_polygons_source', {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: [],
              },
            });

            map.addLayer({
              id: '3d-buildings',
              source: 'composite',
              'source-layer': 'building',
              filter: ['==', 'extrude', 'true'],
              type: 'fill-extrusion',
              minzoom: 15,
              paint: {
                'fill-extrusion-color': '#aaa',
                'fill-extrusion-height': {
                  type: 'identity',
                  property: 'height',
                },
                'fill-extrusion-base': {
                  type: 'identity',
                  property: 'this.sites',
                },
                'fill-extrusion-opacity': 0.6,
              },
            });

            map.addLayer({
              id: 'place_polygons_fill_layer',
              type: 'fill-extrusion',
              source: 'cinema_polygons_source',
              paint: {
                'fill-extrusion-opacity': 0.3,
                'fill-extrusion-height': {
                  property: 'extrusion',
                  type: 'identity',
                },
                'fill-extrusion-base': 0,
                'fill-extrusion-color': colors.primary,
              },
            });

            map.addLayer({
              id: 'place_polygons_line_layer',
              type: 'line',
              source: 'cinema_polygons_source',
              paint: {
                'line-color': colors.primary,
              },
            });

            map.addLayer({
              id: 'cinemas',
              type: 'circle',
              source: 'cinemas',
              filter: ['!has', 'point_count'],
              paint: {
                'circle-opacity': ['match', ['get', 'isActive'], 'true', 0.75, 'false', 1, 1],
                'circle-color': [
                  'match',
                  ['get', 'isActive'],
                  'true',
                  'rgba(0,224,116,128)',
                  'false',
                  colors.primary,
                  colors.primary,
                ],
                'circle-radius': ['match', ['get', 'isActive'], 'true', 20, 'false', 12, 12],
                'circle-stroke-width': ['match', ['get', 'isActive'], 'true', 0, 'false', 1, 1],
                'circle-stroke-color': '#fff',
              },
            });

            this.setMapDataSource(map);
            this.isMapLoaded = true;
          });
          map.addControl(new mapboxgl.NavigationControl());

          const activateCinema = (e) => {
            this.lastClickedOnCinemaAt = DateTime.local();

            if (this.lastPopup != null) {
              this.lastPopup.remove();
            }
            this.selectedCinema = this.cinemasWithShowtimes.find((x) => x.id === e.features[0].properties.id);
            setTimeout(() => {
              this.map.resize();
              this.map.easeTo({
                center: [this.selectedCinema.location.lon, this.selectedCinema.location.lat],
              });
            }, 100);
          };
          map.on('click', 'place_polygons_fill_layer', activateCinema);
          map.on('click', 'cinemas', activateCinema);
          map.on('click', (e) => {
            if (this.lastClickedOnCinemaAt == null || DateTime.local().diff(this.lastClickedOnCinemaAt) > 100) {
              this.selectedCinema = null;
              setTimeout(() => this.map.resize(), 100);
            }
          });

          this.map = map;
        }
      },
      async searchMovies() {
        this.movieSearchResults = await internationalShowtimesApi.instance.searchMovies(
          this.movieSearchTerm,
          this.showOnlyUpcomingMovies,
        );
        // const tmdbSearchResults = await theMovieDBApi.instance.searchMovies(this.movieSearchTerm);
        // console.log(tmdbSearchResults);
      },
      async searchSimilarMovies() {
        const result = await internationalShowtimesApi.instance.searchMoviesByGenres(
          this.selectedGenres.map((g) => g.id),
        );
        this.similarMovies = {
          meta_info: result.meta_info,
          movies: result.movies.filter((x) => x.slug !== this.activeFullMovie.slug),
        };
        this.matchInternationalShowtimeMoviesWithTheMovieDB();
      },
      async getSimilarMoviesFromTheMovieDB() {
        this.topRecommendations = [];
        this.similarMoviesFromTheMovieDB = [];
        this.similarMoviesPage = 1;
        this.similarMoviesComputedPage = 1;
        let response = null;
        const iterate = async () => {
          if (
            this.similarMoviesPage < 100 &&
            (response == null || response.data.total_pages > this.similarMoviesPage)
          ) {
            response = await theMovieDBApi.instance.getSimilarMovies(this.activeMovie, this.similarMoviesPage);
            this.similarMoviesFromTheMovieDB = [...this.similarMoviesFromTheMovieDB, ...response.data.results];
            this.similarMoviesPage += 1;

            if (response.data.total_pages > this.similarMoviesPage) {
              const remaining = Number.parseInt(response.headers['x-ratelimit-remaining'], 10);
              const reset = Number.parseInt(response.headers['x-ratelimit-reset'], 10);
              if (remaining > 0) {
                setTimeout(iterate, 0);
              } else {
                const resetsOn = DateTime.fromMillis(reset);
                setTimeout(iterate, resetsOn.diff(DateTime.local()) + 100);
              }
            } else {
              // console.log('similarMoviesFromTheMovieDB');
              // console.log(this.similarMoviesFromTheMovieDB);
              this.similarMoviesTotalPages = response.data.total_pages;
              this.matchInternationalShowtimeMoviesWithTheMovieDB();
            }
          }
        };

        iterate();
      },
      matchInternationalShowtimeMoviesWithTheMovieDB() {
        if (this.similarMoviesFromTheMovieDB == null || this.similarMovies == null) {
          return;
        }
        this.topRecommendations = this.similarMoviesFromTheMovieDB.filter((m1) =>
          this.similarMovies.movies.find((m2) => m2.tmdb_id == m1.id),
        );
        // console.log('matchingMovies');
        // console.log(matchingMovies);
      },
      async moreSimilarMoviesFromTheMovieDB() {
        let result = null;
        while (
          (this.filteredSimilarMovies == null ||
            this.filteredSimilarMovies.length < (1 + this.similarMoviesComputedPage) * SIMILAR_MOVIES_PAGE_SIZE) &&
          (result == null || result.total_pages > this.similarMoviesPage)
        ) {
          result = await theMovieDBApi.instance.getSimilarMovies(this.activeMovie, this.similarMoviesPage);
          this.similarMoviesFromTheMovieDB = [...this.similarMoviesFromTheMovieDB, ...result.results];
          this.similarMoviesPage += 1;
          // console.log(this.similarMovies);
        }
        this.similarMoviesComputedPage += 1;
      },
      async findCities(query) {
        if (this.findCitiesTimer != null) {
          clearTimeout(this.findCitiesTimer);
        }
        this.findCitiesTimer = setTimeout(async () => {
          this.findCitiesTimer = null;
          if (query === null || query === '') {
            return [];
          }
          if (this.cancelTokenSource != null) {
            this.cancelTokenSource.cancel();
          }
          this.cancelTokenSource = axios.CancelToken.source();
          const result = await internationalShowtimesApi.instance.searchCities(query, this.cancelTokenSource);
          this.cancelTokenSource = null;
          this.cities = result.cities
            .map((x) => {
              return { id: x.id, name: x.name, displayName: `${x.name}, ${x.country}`, slug: x.slug };
            })
            .sort((a, b) => a.displayName.localeCompare(b.displayName));
        }, 200);
      },
      async getCinemas() {
        if (this.selectedCity == null) {
          return null;
        }

        const result = await internationalShowtimesApi.instance.getCinemas(this.selectedCity.id);
        this.cinemas = result.cinemas;

        const coordinates = this.cinemas.map((x) => [x.location.lon, x.location.lat]);
        const geoJSONResult = await orgAppApi.instance.getBuildingsAtCoordinates(coordinates);
        geoJSONResult.forEach((x, i) => {
          if (x != null) {
            this.cinemas[i].geoJson = x;
          }
        });
        this.initMap();
        this.setMapDataSource(this.map);
        // console.log(this.cinemas);
      },
      async getShowtimes() {
        if (this.selectedCity == null) {
          return null;
        }

        const promises = this.selectedSimilarMovies.map((m) =>
          internationalShowtimesApi.instance.getShowtimes(m.id, this.selectedCity.id),
        );
        const results = await Promise.all(promises);
        this.showtimes = {};
        this.selectedSimilarMovies.forEach((m, i) => {
          this.showtimes[m.id] = results[i].showtimes;
        });
        this.setMapDataSource(this.map);
        // console.log('showtimes');
        // console.log(this.showtimes);
        // console.log('showtimesForSelectedMoviesAndCity');
        // console.log(this.showtimesForSelectedMoviesAndCity);
      },
      async activateMovie(e, movie) {
        window.document.getElementById('edit_movieAudience').scrollTop = 0;
        this.activeFullMovie = (await internationalShowtimesApi.instance.getMovie(movie.id)).movie;
        // console.log('activeFullMovie');
        // console.log(this.activeFullMovie);
        const tmdbMovie = await theMovieDBApi.instance.getMovie(this.activeFullMovie.tmdb_id);
        this.activeMovie = tmdbMovie;
      },
      addToSelection(e, movie) {
        this.selectedSimilarMovies.push(movie);
        // console.log(this.selectedSimilarMovies);
      },
      removeFromSelection(e, movie) {
        this.selectedSimilarMovies.splice(this.selectedSimilarMovies.indexOf(movie), 1);
      },
      startOver() {
        this.activeMovie = null;
        this.clearCity();
        this.selectedSimilarMovies = [];
        this.wizardStep = 1;
      },
      clearCity() {
        this.selectedCity = null;
        this.showtimes = null;
        this.cinemas = null;
        this.map = null;
      },
      toggleGenre(genre) {
        const existingSelection = this.selectedGenres.find((x) => x.id === genre.id);
        if (existingSelection != null) {
          if (this.selectedGenres.length === 1) {
            return;
          }
          this.selectedGenres.splice(this.selectedGenres.indexOf(existingSelection), 1);
        } else {
          this.selectedGenres.push(genre);
        }
      },
      getMoviePosterUrl(id) {
        let movie = this.selectedSimilarMovies.find((x) => x.id == id);
        if (movie == null) {
          if (this.selectedSimilarMovies.length == 0) {
            return null;
          }
          [movie] = this.selectedSimilarMovies;
        }
        return movie.poster_image_thumbnail != null
          ? movie.poster_image_thumbnail.replace('w154', 'w500')
          : `https://image.tmdb.org/t/p/w500/${movie.poster_path}`;
      },
      capitalize(text) {
        return capitalize(text);
      },
      save() {
        this.errors.clear();
        this.$validator.validateAll(this.movieAudience).then(
          () => {
            if (this.entityTimestamp.equals(this.movieAudience.timestamp)) {
              this.exit();
            } else if (this.movieAudience.id === -1) {
              this.saveChangesModalConfirmed();
            } else {
              this.isSaveChangesModalVisible = true;
            }
          },
          () => {
            const message = `${i18n.global.t('messages.failedToSaveMovieAudience')}<br/>${this.$validator.messageBag.htmlErrorList}`;
            UserNotifications.error({
              title: i18n.global.t('messages.missingRequiredValue'),
              message,
            });
            this.errors = this.$validator.messageBag.errors;
          },
        );
      },
      cancel() {
        this.exit();
      },
      exit() {
        if (!this.isNew) {
          this.$router.push(this.detailsEndpoint);
        } else {
          this.$router.push(this.listEndpoint);
        }
      },
      async saveChangesModalConfirmed() {
        try {
          if (this.newOrExistingAdvertiser === 'new') {
            if (this.newAdvertiser.iabCategories.length === 0) {
              this.newAdvertiser.iabCategories.push(1);
            }
            const advertiser = await this.saveAdvertiser(this.newAdvertiser);
            this.advertiserID = advertiser.id;
          }

          if (this.newOrExistingAccount === 'new') {
            const account = await this.saveAccount(this.newAccount);
            this.accountID = account.id;
          }

          const movieAudience = await this.saveMovieAudience(this.movieAudience);
          this.entityTimestamp = DateTime.fromISO(this.movieAudience.timestamp);
          this.isSaveChangesModalVisible = false;
          const capitalize = capitalize;
          UserNotifications.success({
            title: capitalize(i18n.global.t('names.success', { n: 1 })),
            message: i18n.global.t('messages.movieAudienceSavedSuccessfully'),
          });
          this.$router.push(movieAudience.endpoint);
        } catch (e) {
          this.isSaveChangesModalVisible = false;
          throw e;
        }
      },
      saveChangesModalCancelled() {
        this.isSaveChangesModalVisible = false;
      },
      safeInitMap() {
        const timer = setInterval(() => {
          if (window.document.getElementById('map') != null) {
            clearInterval(timer);
            this.initMap();
          }
        }, 100);
      },
      async saveGeofencesAndCreateAudience() {
        //
        // Save geofence group
        //
        let geofenceGroup = await this.createNewGeofenceGroup(GeofenceGroupType.AUDIENCE);
        geofenceGroup.name = this.activeMovie.title;
        geofenceGroup.description = `Audience geofence group targeting people who might want to watch "${this.activeMovie.title}".`;

        // Check for geofence group with same name (since we can't have duplicates)
        const { totalCount } = await this.getGeofenceGroups({
          queryParams: QueryParams.for({
            top: 1,
            filterCollection: FilterCollection.for(
              'name',
              [this.activeMovie.title],
              FilterComparisonOperator.STARTS_WITH,
            ),
          }),
        });
        if (totalCount > 0) {
          geofenceGroup.name = `${this.activeMovie.title} (${totalCount})`;
        }

        geofenceGroup = await this.saveGeofenceGroup({ geofenceGroup });

        //
        // update geofences geofenceGroupID
        //
        const geofences = this.cinemasWithShowtimes?.map((c) =>
          Geofence.fromObject({
            geofenceGroupID: geofenceGroup.id,
            name: c.name,
            description: c.location.address.display_text,
            tags: null,
            lat: c.location.lat,
            lng: c.location.lon,
            geoJson: c.geoJson != null ? JSON.stringify(c.geoJson.geometry) : undefined,
          }),
        );

        this.updateGeofenceGroupGeofences({
          geofenceGroup: geofenceGroup,
          value: geofences,
        });

        await this.saveGeofences(geofenceGroup);

        // Touch geofencegroup to trigger geofence-site processing
        await this.saveGeofenceGroup({ geofenceGroup });

        //
        // Create custom audience
        //
        const dataProviders = await this.getAllDataProviders();
        if (dataProviders.length === 0) {
          return;
        }

        const audienceLogic = await this.createNewAudienceLogic();
        audienceLogic.name = `Custom audience for "${this.activeMovie.title}"`;
        audienceLogic.logicalExpression = '1';
        audienceLogic.dataProviderID = dataProviders[0].id;

        audienceLogic.audienceRules.push(
          AudienceRule.fromObject({
            key: 1,
            name: this.activeMovie.title,
            mode: AudienceRuleModes.Geofence,
            geofenceGroupID: geofenceGroup.id,
            daypart: FullDaypart,
          }),
        );
        audienceLogic.audienceRules[0].audienceLookbackWindows = [
          AudienceLookBackWindow.fromObject({
            fromDate: null,
            toDate: null,
            timePeriod: 12,
          }),
        ];

        if (this.isNew) {
          await this.createAudienceLogics({ instances: audienceLogic });
        } else {
          await this.updateAudienceLogic({ instance: audienceLogic });
        }

        this.$router.push(geofenceGroup.endpoint);
      },
      onTabChanged(tab) {
        this.selectedTab = tab;
        if (this.selectedTab != null && this.selectedTab.id === 'tabmapInternal' && this.map != null) {
          setTimeout(() => {
            this.map.resize();
          }, 100);
        }
      },
      onCursorMouseDown(e) {
        // console.log(e);
        this.startingTimelineHourIndex = this.timelineHourIndex;
        this.timelineWidth = window.document.getElementsByClassName('timeline')[0].offsetWidth;
        this.timelineHourWidthInPixels = (this.timelineWidth * this.timelineHourWidth) / 100;
        this.dragStartedAt = e.clientX;
        this.isTimelinePlaying = false;
      },
      onCursorMouseUp(e) {
        this.dragStartedAt = null;
      },
      onCursorMouseMove(e) {
        if (this.dragStartedAt == null) {
          return;
        }
        // console.log(e);
        const x = e.clientX - this.dragStartedAt;
        this.timelineHourIndex = Math.min(
          Math.max(0, this.startingTimelineHourIndex + Math.floor(x / this.timelineHourWidthInPixels)),
          this.showtimesByHour.length - 1,
        );
      },
      startTimelinePlayback() {
        this.timelinePlaybackTimer = setInterval(() => {
          if (this.timelineHourIndex < this.showtimesByHour.length - 1) {
            this.timelineHourIndex += 1;
          } else {
            this.timelineHourIndex = 0;
          }
        }, 100);
      },
      stopTimelinePlayback() {
        clearInterval(this.timelinePlaybackTimer);
      },
      updateActiveCinemasOnMap() {
        const features = [];
        this.cinemasWithShowtimes.forEach((cinema) => {
          features.push({
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [cinema.location.lon, cinema.location.lat],
            },
            properties: {
              id: cinema.id,
              title: cinema.name,
              name: cinema.name,
              isActive:
                this.timelineCurrentShowtimes == null
                  ? 'false'
                  : `${this.timelineCurrentShowtimes.some((st) => st.cinema_id === cinema.id)}`,
            },
          });
        });
        if (this.map.getSource('cinemas') != null) {
          this.map.getSource('cinemas').setData({
            type: 'FeatureCollection',
            features,
          });
        }
      },
    },
    watch: {
      activeMovie(val) {
        if (val != null) {
          this.selectedGenres = [...this.activeFullMovie.genres];
          this.searchSimilarMovies();
          // this.getSimilarMoviesFromTheMovieDB();
        } else {
          this.selectedSimilarMovies = [];
        }
      },
      selectedCity(val) {
        if (val != null) {
          this.getCinemas();
          this.getShowtimes();
        }
      },
      selectedGenres() {
        this.searchSimilarMovies();
      },
      selectedSimilarMovies(val) {
        // console.log('selectedSimilarMovies');
        // console.log(val);
      },
      showOnlyUpcomingMovies() {
        this.searchMovies();
      },
      showtimes(val) {
        if (val) {
          this.safeInitMap();
        }
      },
      isTimelinePlaying(val) {
        if (val) {
          this.startTimelinePlayback();
        } else {
          this.stopTimelinePlayback();
        }
      },
      timelineHourIndex() {
        this.updateActiveCinemasOnMap();
      },
    },
    beforeMount() {
      if (this.isNew) {
        window.document.title = 'New Movie Audience'; // capitalize(i18n.global.t('actions.newMovieAudience'));
      }
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  #app {
    .light-text {
      color: #ffffffcc;
    }

    .edit-movie-audience {
      margin-bottom: -0.5rem;
      background-position: center;

      &.pad-bottom {
        padding-bottom: 32rem;
      }
    }

    button.btn-no-borders {
      border: none;
      background: none;
      cursor: pointer;

      svg {
        width: 2.4rem;
        height: 2.4rem;
        fill: #fff;
        stroke: #fff;
      }

      &.btn-no-borders-lg {
        svg {
          width: 3.2rem;
          height: 3.2rem;
        }
      }

      &.btn-no-borders-xl {
        svg {
          width: 4.8rem;
          height: 4.8rem;
        }
      }
    }

    .veil {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 23rem;
      background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.7));
    }

    .main-content.expanded {
      .veil {
        left: 5rem;
      }
    }

    .hidden {
      transform: scaleY(0);
      height: 0;
      opacity: 0;
      transition: all 1s cubic-bezier(0.2, 1, 0.2, 1);
    }

    .visible {
      transform: scaleY(1);
      height: auto;
      opacity: 1;
      transition: all 1s cubic-bezier(0.2, 1, 0.2, 1);
    }

    .muted {
      font-size: 0.9em !important;
      color: #ffffff77 !important;
    }

    .wizard-header {
      transition: all 1s cubic-bezier(0.2, 1, 0.2, 1);
      transform-origin: top;
      background-size: cover;
      background-position: center;
      border-bottom: solid 0.1rem #ffffff66;

      .active-movie {
        padding: 1.6rem;
        display: flex;
        align-items: center;

        img {
          height: 12.8rem;
          box-shadow: 0 0rem 1.2rem rgba(0, 0, 0, 1);
          margin-right: 2.4rem;
        }

        span {
          color: #fff;
          text-shadow: 0 0 1rem #000;
          font-size: 1.2em;

          &.title {
            font-weight: 900;
            font-size: 2em;
          }
        }
      }
    }

    .movie-search {
      display: flex;
      flex-direction: column;
      align-items: center;

      .header {
        font-weight: bold;
        margin-bottom: 1.6rem;
      }

      .footer {
        color: var(--textMutedColor);

        font-size: 0.9em;
      }

      .textbox-and-button {
        align-content: center;
        display: flex;
        align-items: center;
        flex-basis: 50%;
        width: 40vw;
        margin-bottom: 1.6rem;

        .form-control {
          margin-right: 1rem;
          font-size: 1.7rem;
        }
      }
    }

    .movie-search-results {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      transition: all 1s cubic-bezier(0.2, 1, 0.2, 1);

      .movie-result {
        width: 25%;
        max-width: 30rem;
        margin: 1.6rem;
        box-shadow: 0 0.6rem 1.2rem rgba(0, 0, 0, 0.5);
        position: relative;

        .poster {
          max-width: 100%;
        }

        .overlay {
          background: rgba(0, 0, 0, 0.4);
          opacity: 0;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        &:hover {
          .overlay {
            opacity: 1;
          }
        }
      }
    }

    .movie-search-no-results {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      svg {
        height: 25.6rem;
        width: 25.6rem;
      }
    }

    .similar-movie-result {
      width: 20%;
      max-width: 30rem;
      margin: 1.6rem;
      box-shadow: 0 0.6rem 1.2rem rgba(0, 0, 0, 0.5);
      position: relative;

      .poster {
        max-width: 100%;
      }

      .overlay {
        background: rgba(0, 0, 0, 0.4);
        opacity: 0;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.disabled {
          opacity: 1 !important;
          background: #00000099;
        }
      }

      &:hover {
        .overlay {
          opacity: 1;
        }
      }
    }

    .similar-movie-search-results {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      transition: all 1s cubic-bezier(0.2, 1, 0.2, 1);

      .more-similar-movie-results {
        width: 20%;
        margin: 1.6rem;
        box-shadow: 0 0.6rem 1.2rem rgba(0, 0, 0, 0.5);
        position: relative;

        .overlay {
          background: rgba(0, 0, 0, 0.4);
          opacity: 0;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        &:hover {
          .overlay {
            opacity: 1;
          }
        }
      }
    }

    .selected-similar-movies {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      transition: all 1s cubic-bezier(0.2, 1, 0.2, 1);

      .similar-movie-result {
        width: auto;

        img {
          max-height: 12.8rem;
          width: auto;
        }
      }

      h4 {
        text-align: right;
        margin-right: 1.6rem;
      }

      &.floating {
        align-items: center;
        position: fixed;
        bottom: 0;
        right: 0;
        left: 23rem;
        background: #000;
        box-shadow: 0 -0.5rem 1rem #000;
        border-top: solid 0.1rem #ffffff22;
        padding: 1.6rem;

        .similar-movie-result {
          width: auto;
        }

        .movie-list {
          justify-content: flex-start;
        }
      }

      .movie-list {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
      }
    }

    .main-content.expanded {
      .selected-similar-movies {
        &.floating {
          left: 5rem;
        }
      }
    }

    .multiselect {
      width: 40rem;
    }

    .genres {
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        margin: 0 0.8rem;
      }
    }

    .map-container {
      display: flex;
      flex-direction: row;
      height: calc(100vh - 32rem);

      .cinema-details {
        min-width: 40rem;
        width: 40rem;
        background: #ffffff1f;
        margin-right: 1.6rem;
        padding: 0.8rem 1.6rem;
        overflow-y: auto;

        .title {
          font-size: 1.2em;
          font-weight: 600;
        }

        .chain-logo {
          max-height: 6.4rem;
        }

        .movies {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .movie-showtimes {
            display: flex;
            flex-direction: column;
            flex-basis: 47%;

            img {
              width: 100%;
            }
          }
        }
      }

      .map-and-timeline {
        flex-grow: 1;
        width: 100%;

        .timeline-and-controls {
          margin-top: 1rem;
          height: 5rem;
          display: flex;
          align-items: center;
        }

        .controls {
          margin-right: 0.8rem;
          width: 7rem;
        }

        .timeline {
          flex-grow: 1;
          height: 5rem;
          background: #ffffff33;
          position: relative;
          display: flex;
          align-items: flex-end;

          .cursor {
            width: 0.5rem;
            position: absolute;
            top: 0;
            bottom: 0;
            cursor: ew-resize;

            .bar {
              top: 0;
              bottom: 0;
              margin-left: 0.2rem;
              background: #fff;
              width: 0.1rem;
              height: 100%;
            }

            .cursor-tooltip {
              position: absolute;
              top: -3.2rem;
              width: 10rem;
              text-align: center;
              margin-left: -5rem;
              font-size: 0.7em;
              border-radius: 1.6rem;
              padding: 0.4rem 0.8rem;

              background-color: var(--info);
              color: var(--infoReverse);
            }
          }

          .hour {
            height: 100%;
            display: flex;
            align-items: flex-end;

            .bar {
              width: 0.1rem;

              background-color: var(--actionsColor);
            }
          }
        }
      }

      #map {
        flex-grow: 1;
        width: 100%;
        height: calc(100vh - 38rem);
        background: #000;
      }
    }

    h4 {
      text-shadow: 0 0.1rem 0.5rem #000;
    }

    .separator {
      display: flex;
      align-items: center;

      .line {
        flex-grow: 1;
        height: 0.1rem;
        background: #ffffff33;
        margin: 0 1.6rem;

        &:first-of-type {
          margin-left: 10%;
        }

        &:last-of-type {
          margin-right: 10%;
        }
      }

      .text {
        font-size: 1.2em;
        font-weight: 600;
      }
    }

    .api-logos {
      display: flex;
      justify-content: center;
      margin-bottom: 0.5rem;

      svg {
        height: 4rem;
        margin: 1.6rem;
      }
    }
  }
</style>
